module.exports = __webpack_public_path__ + "img/menu-bar_04.5ea8bbfe.png";